import { createContext } from "react";

export const RewardsViewContext = createContext();

